import { render, staticRenderFns } from "./AmountsPageHeader.vue?vue&type=template&id=2860b17c&scoped=true&"
import script from "./AmountsPageHeader.vue?vue&type=script&lang=js&"
export * from "./AmountsPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./AmountsPageHeader.vue?vue&type=style&index=0&id=2860b17c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860b17c",
  null
  
)

export default component.exports